import appendSnsBtns from "../utils/sns_share_buttons/appendSnsBtns";
import setDummyFormValue from "../utils/setDummyFormValue";
import mobileNavDrawer from "../utils/mobileNavDrawer";

if (document.body.matches('.customer_stories.index')) {
  setDummyFormValue();
}

if (document.body.matches('.customer_stories.show')) {
  appendSnsBtns();
}

if (document.body.matches('.customer_stories.sp')) {
  mobileNavDrawer();
}